/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

interface PromptData {
  type:string ;
  details: string;
  isEdit:boolean;
  editDisabled:boolean
}


@Component({
  selector: 'app-prompt-menu',
  templateUrl: './prompt-menu.component.html',
  styleUrls: ['./prompt-menu.component.scss'],
})


export class PromptMenuComponent  implements OnInit {

  constructor(public utilService:UtilsService,private cdr:ChangeDetectorRef) { }

  llmPrompt:string=JSON.stringify(this.utilService.generatedPrompt)
  sqlPrompt:string=this.utilService.generatedSql
  question:string=this.utilService.generatedQuestion
  oldQuestion:string=this.utilService.generatedQuestion
  
  
  detailsEdit:boolean=false;
  isEditPromptOpen:boolean=false;
  isContentEditable:boolean=true;
  content:string=""
  promptType:string=""
  selectedVersion:number=1;
  versionList:number=0;

  @Input() TrainingId:any;
  @Input() resultIndex:any;
  @Input() processTypes:any;
  @Input() qid:any;


  promptDetails: PromptData[]=this.utilService.updatedPromptDetails
  

  


  ngOnInit() {
    this.selectedVersion=this.utilService.currentVersion
    this.utilService.detailsChanged=false
    
  }


  cancel(){
    this.question=this.oldQuestion
    this.utilService.generatedQuestion=this.oldQuestion
    this.utilService.updatedPromptDetails.forEach(item => {
      if (item.isEdit) {
        item.details = this.oldQuestion;
      }
    });
    this.utilService.updatedPromptDetails.forEach(item => {
      item.isEdit = false
      item.editDisabled=false;
    }
  );
  }
  save(){
    
    this.utilService.updatedPromptDetails.forEach(item => {
      if (item.isEdit) {
        item.details = this.question;
      }
    });
    this.promptDetails.forEach(item => {item.isEdit = false
      item.editDisabled=false;
    }
  );
  this.utilService.updatedChatMessages=this.utilService.updatedChatMessages.map((item) => {
    if (item.question === this.utilService.generatedQuestion) {
      return { ...item, question: this.question };
    }
    return item; 
  });
  
  this.utilService.reGenerateSql(this.question,'Question',this.resultIndex)
  }
 
  editBlock(block: string,details:string,editable:boolean) {
    
    this.content=details
    this.isEditPromptOpen=true
    this.isContentEditable=!editable
    this.utilService.updatedPromptDetails.forEach(item => {
    item.isEdit = (item.type === block);
    item.editDisabled=(item.type !== block)
  });
  
  this.content=details
  this.promptType=block

 
}
openEditPromptMenu(details:any,type:string,editable:boolean){
  this.content=details
  this.isEditPromptOpen=true
  this.promptType=type
  this.isContentEditable=!editable
}
  closeEditPromptMenu(updatedContent: any){
 
   if(updatedContent.action){
    this.utilService.updatedPromptDetails.forEach(item => {
     
      if (item.isEdit) {
        item.details = updatedContent.content;
        this.utilService.reGenerateSql(updatedContent.content,item.type,this.resultIndex)
      }
    });
  }
    this.utilService.updatedPromptDetails.forEach(item => {item.isEdit = false
      item.editDisabled=false;
    }
  );
    this.isEditPromptOpen=false;
   
    this.cdr.detectChanges();
    
  }
  selectSchema(num:number) {
    this.utilService.selectedVersion= num;
    if(this.utilService.trainedQuestionVersions.length!=0){
        this.utilService.getVersion(this.resultIndex)
    }
  }
  
}
